/* Juegos de Cortita y al pie: estado común y premio acumulado (5% por juego ganado cada día) */
window.CortitaJuegos=(function(){
  const today=new Intl.DateTimeFormat("en-CA",{timeZone:"Europe/Madrid",year:"numeric",month:"2-digit",day:"2-digit"}).format(new Date());
  const get=k=>{try{return JSON.parse(localStorage.getItem(k))}catch(e){return null}};
  const set=(k,v)=>{try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}};
  const HUB="/pages/juegos", PER=5;
  const games=[
    {id:"crack",name:"El crack del día",url:"/pages/el-crack-del-dia",key:"crack-"+today,won:s=>!!s.won},
    {id:"camiseta",name:"Adivina la camiseta",url:"/pages/adivina-la-camiseta",key:"cam-d"+today,won:s=>!!s.teamOk}
  ];
  function status(g){const s=get(g.key);if(!s||!s.done)return(s&&s.g&&s.g.length)?"playing":"pending";return g.won(s)?"won":"lost"}
  function summary(){
    const list=games.map(g=>Object.assign({},g,{state:status(g)}));
    const wins=list.filter(x=>x.state==="won").length;
    return {games:list,wins,pct:wins*PER,max:games.length*PER,allDone:list.every(x=>x.state==="won"||x.state==="lost"),today};
  }
  const claimKey="juegos-premio-"+today;
  const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));

  /* Caja de premio para el pop-up final de cada juego */
  let css=false;
  function injectCss(){if(css)return;css=true;const st=document.createElement("style");st.textContent=`
    .jg-box{background:#E8F2F4;border-radius:1.2rem;padding:1.6rem 1.8rem;display:flex;flex-direction:column;gap:1.2rem;color:#3D3D3D}
    .jg-box p{margin:0;font-size:1.5rem;line-height:1.5}
    .jg-box b{font-weight:500}
    .jg-bar{display:flex;gap:.6rem}
    .jg-bar span{flex:1;height:.9rem;border-radius:1rem;background:rgba(71,97,108,.18)}
    .jg-bar span.on{background:#3F7D58}
    .jg-row{display:flex;gap:1rem;flex-wrap:wrap}
    .jg-btn{font:inherit;font-size:1.5rem;letter-spacing:.1rem;padding:1.3rem 2.4rem;border-radius:.8rem;background:#47616C;color:#fff;text-decoration:none;display:inline-flex;align-items:center;box-shadow:0 0 0 1px #47616C}
    .jg-btn:hover{box-shadow:0 0 0 2px #47616C}
    .jg-btn--ghost{background:transparent;color:#47616C;box-shadow:inset 0 0 0 1px #47616C}
    .jg-btn--ghost:hover{box-shadow:inset 0 0 0 2px #47616C}`;document.head.appendChild(st)}
  function prizeBox(myId,won){
    injectCss();
    const s=summary(), claimed=!!get(claimKey);
    const pending=s.games.filter(g=>g.id!==myId&&(g.state==="pending"||g.state==="playing"));
    const bar=`<div class="jg-bar" aria-hidden="true">${s.games.map(g=>`<span class="${g.state==="won"?"on":""}"></span>`).join("")}</div>`;
    let txt=(won?`Sumas <b>+${PER}%</b> a tu premio de hoy. `:`Este juego hoy no suma. `)+`Llevas <b>${s.pct}%</b> de ${s.max}%.`;
    let btns="";
    if(pending.length){
      txt+=` Te queda ${pending.map(g=>`<b>${esc(g.name)}</b>`).join(" y ")}: cuando lo termines, reclama tu descuento en Juegos.`;
      btns=pending.map(g=>`<a class="jg-btn" href="${g.url}">Jugar a ${esc(g.name)}</a>`).join("")+`<a class="jg-btn jg-btn--ghost" href="${HUB}">Ir a Juegos</a>`;
    } else if(s.pct>0){
      txt+=claimed?` Ya has reclamado tu premio de hoy.`:` Ya has jugado a todo lo de hoy.`;
      btns=`<a class="jg-btn" href="${HUB}">${claimed?"Ver mi código":`Reclamar mi ${s.pct}%`}</a>`;
    } else {
      txt+=` Mañana hay retos nuevos.`;
      btns=`<a class="jg-btn jg-btn--ghost" href="${HUB}">Ir a Juegos</a>`;
    }
    return `<div class="jg-box">${bar}<p>${txt}</p><div class="jg-row">${btns}</div></div>`;
  }
  return {today,games,summary,prizeBox,claimKey,get,set,HUB,PER};
})();
